// extracted by mini-css-extract-plugin
export var calendarView = "_ls-0";